import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';

export const getHoldbackList = () => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Holdback_List,
      },
    ],
  });
};

export const releaseHoldback = (balanceId: number) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Holdback_Release,
        payload: { balanceId },
      },
    ],
  });
};

export const upsertHoldback = (payload: {
  id?: number;
  balanceId: number;
  holdType: string;
  holdFix: number;
  holdPercent: number;
  holdPercentPeriod: number;
  contractConditionsId: number;
  dateStart?: string;
  status: string;
  comment: string;
}) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Holdback_Upsert,
        payload,
      },
    ],
  });
};
